import { Assert } from '@team/assert';
import { ArrayKit } from '@team/array';
import { type SafeAreaInsets } from './types';

export const CUSTOM_PROPERTY_INSET_PREFIX = '--tgui--safe-area-inset-';
export const CUSTOM_PROPERTY_CONTENT_INSET_PREFIX =
  '--tgui--content-safe-area-inset-';

export function setSafeAreaInsets(
  insets: Maybe<SafeAreaInsets>,
  customPropertyPrefix: string,
  ...containers: Maybe<HTMLElement>[]
): VoidFunction {
  if (Assert.isUndefined(insets)) {
    return () => void 0;
  }

  const definedContainers = containers.filter(Assert.isDefined);

  if (ArrayKit.isEmpty(definedContainers)) {
    return () => void 0;
  }

  Object.entries(insets).forEach(([key, value]) => {
    if (Assert.isUndefined(value)) {
      return;
    }

    const propertyKey = `${customPropertyPrefix}${key}`;
    const propertyValue = `${value}px`;

    definedContainers.forEach((element) => {
      element.style.setProperty(propertyKey, propertyValue);
    });
  });

  return function unsetSafeAreaInsets() {
    Object.keys(insets).forEach((key) => {
      const propertyKey = `${customPropertyPrefix}${key}`;

      definedContainers.forEach((element) => {
        element.style.removeProperty(propertyKey);
      });
    });
  };
}
